import birthChartCardCopy from '../../../components/pages/BirthChart/BirthChartChatCard/copy';
import birthChartFlowCopy from '../../../components/pages/BirthChart/BirthChartFlow/copy';
import birthChartViewCopy from '../../../components/pages/BirthChart/BirthChartView/copy';

export const enTranslation = {
    catalog: {
        filters: {
            title: 'ADVISOR CATEGORIES',
            results: '{{number}} results',
            label: 'Filters {{number}}'
        },
        pageTitle: " Connecting you to the spirit realm for love, finances + life's purpose",
        pageTopTitle: 'Empathy Meets AI',
        collageTitle: 'Enlighten Your Journey with Our AI Spiritual Guides',
        collageSubTitle: 'Cultivate Love, Compassion, and Fulfilling Relationships',
        cardTitle: "Unlocking Love's Oracle: AI Spiritual Guides for You",
        bigCardTitle: "This Month's Featured AI Spiritual Guide",
        bigCardTitle2: 'Meet Aviva, our AI Intimacy Expert',
        bigCardTitleText: 'Dream Interpreter',
        bigCardTitle2Text: 'Intimacy Coach',
        paymentHistory: 'Payments history',
        multiTitle: 'Start a Group Chat',
        multiSubtitle: 'Deepen your relationships + Uncover unique insights',
        singleTitle: 'Start a Chat',
        singleSubtitle: 'Deepen your relationships + Uncover unique insights'
    },
    // HORO-10563: CatalogPageV2's own copy namespace. Kept separate from
    // `buttons.registerToChat`/`buttons.subscribeToChat` (v1 uppercases those
    // via CSS) so v2's Title Case labels can't accidentally change v1's.
    catalogV2: {
        title: 'MEET ADVISORS',
        premiumTag: 'Premium',
        lockedTag: 'Locked',
        cta: {
            startChat: 'Start a Chat',
            registerToChat: 'Register to Chat',
            subscribeToUnlock: 'Subscribe to Unlock',
            zaraRegisterToChat: 'Send a free message'
        },
        // HORO-10599: shown under Zara's CTA only — see advisorCardModel.js's
        // ctaSubtextKey.
        zaraRegisterHint: 'Free with registration'
    },
    buttons: {
        chatNow: 'chat now',
        // HORO-10504: locked-advisor catalog card CTAs — see
        // `getAdvisorLockReason` in advisorAccess.js for when each shows.
        registerToChat: 'register to chat',
        subscribeToChat: 'subscribe to chat',
        multiChat: 'Start Multichat',
        spiritGuides: 'Meet Our AI Spiritual Guides',
        logout: 'Log out',
        freeTrial: 'Start Free {{trialDays}}-day Trial',
        freeTrial_offer: 'Start for Free',
        // Replaces the trial CTAs while FREE_TRIAL_ENABLED is off.
        startSubscription: 'Start Your Subscription',
        offer: 'Get offer',
        getOffer: 'Get it now',
        feedback: 'Feedback',
        privacy: 'Privacy',
        privacyPolicy: 'Privacy Policy',
        termsOfService: ' Terms of Service',
        google: 'Continue with Google',
        facebook: 'Continue with Facebook',
        // HORO-10509: short labels for the compact side-by-side OAuth
        // buttons (Sign in screen) — distinct from the full "Continue
        // with X" labels the stacked buttons above still use.
        googleShort: 'Google',
        facebookShort: 'Facebook',
        submit: 'SUBMIT',
        // HORO-10509
        createAccount: 'Create account',
        continue: 'Continue',
        verify: 'Verify',
        signIn: 'Sign in',
        forgotPassword: 'Forgot password?',
        sendCode: 'Send code',
        resetPassword: 'Reset password',
        // HORO-10509 (Figma 4517:31391 / 4542:52114, "Set a new password"):
        // single-field redesign replacing the old combined code+password
        // screen's "Reset password" button.
        updatePassword: 'Update Password',
        // HORO-10509: aria-labels for the password field's show/hide eye
        // toggle — not visible copy, just an accessible name for the
        // icon-only button.
        showPassword: 'Show password',
        hidePassword: 'Hide password',
        back: 'Back',
        close: 'Close',
        submitSm: 'Submit',
        send: 'SEND',
        moreInfo: 'Add birth time information for a more accurate reading',
        resend: 'Resend message',
        backHome: 'Back home',
        toHome: 'To home page',
        save33: 'Save 33% Now!',
        save: 'Save changes',
        // HORO-10544: aria-label for the inline name edit on the profile header.
        editName: 'Edit your name',
        manage: 'Manage Subscription',
        removeAcc: 'Delete account',
        cancel: 'Cancel',
        confirmDelete: 'Confirm deletion',
        msgSub: 'Subscription management',
        subscribe: 'Subscribe',
        retry: 'Retry',
        retrySubscription: 'Retry subscription',
        paymentsHistory: 'Payments history',
        cancelSubscription: 'Cancel subscription',
        creditCard: 'Credit card',
        share: 'Share',
        invite: 'Invite Friends',
        inviteOphelia: 'Start Group Tarot',
        inviteVeda: 'Start Group Horoscope',
        inviteAtlas: 'Get Insights',
        rate: 'Rate',
        joinChat: 'JOIN CHAT',
        tryAgain: 'Try again',
        noThanks: 'No, thanks',
        iAgree: 'I Agree'
    },
    footer: {
        about: 'About us',
        contact: 'Contact us',
        advertising: 'Advertising',
        privacy: 'Privacy',
        terms: 'Terms'
    },
    menu: {
        title: 'Menu',
        catalog: 'Catalog',
        profile: 'Profile',
        profileCreate: 'Create Profile',
        newChat: 'Start New Chat',
        // HORO-10647: renamed from Chat History; the route stays /chat-history.
        history: 'History',
        memory: 'Memory',
        // HORO-10703: the /plans comparison page.
        plans: 'Veda Plans',
        new: 'New'
    },
    errors: {
        birthPlace: 'Please enter your birthplace',
        // HORO-10544: required-name validation on the profile.
        nameRequired: 'Please enter your name',
        number: 'Phone number must contain at least 6 numbers',
        wrong: 'Something went wrong...',
        wrong404: 'Something went wrong',
        changed: 'Chat name was changed',
        notEmptyMessage: 'Message cannot be just spaces',
        maxSymbolMessage: 'The max length of 2000 characters is reached.',
        errorBoundary: 'Please, clear browser cache, check internet connection and try again',
        cantConnect: "Can't connect to chat",
        fileImageLoadError: 'Incorrect file. File must be png or jpg. File limit - 5Mb',
        // HORO-10509: email/password form validation messages. These lived in a
        // SECOND `errors:` block at the end of this object. A duplicate key in an
        // object literal keeps only the last one, so that block silently shadowed
        // every key above it and the app rendered raw strings ("errors.birthPlace",
        // "errors.wrong") to users at 14 call sites. Merged here (HORO-10544).
        invalidEmail: 'Enter a valid email address',
        passwordRequirements: 'At least 8 characters, with 1 number, 1 uppercase letter, and 1 special character',
        passwordsMustMatch: 'Passwords must match',
        invalidCode: 'Enter the 6-digit code'
    },
    labels: {
        noOption: 'Input your birthplace',
        copy: 'COPIED',
        startChat: 'start chat',
        // HORO-10427: AI disclosure shown below every chat input (legal/compliance).
        aiDisclosure: 'You are interacting with an AI system, not a human.',
        // HORO-10599: registered-free trial counter shown above ChatBar's
        // input, Zara chats only — see useZaraTrial.
        zaraTrialCounter: '{{used}} / {{limit}} free messages',
        dateSelect: 'Selected date must be less than the current date',
        selectDate: 'Please select a date and time',
        selectCountry: 'Enter your country',
        chooseCountry: 'Choose your country',
        online: 'Online',
        calToAction: 'START CHAT',
        determine: 'To determine your numerology (optional)',
        noAdvisor: 'No advisors were found',
        noCategory: 'No categories',
        removedChat: 'The chat has been removed',
        noActiveChat: 'You have no active chats yet',
        userHistory: 'Your history',
        forecast: "What's my love life forecast?",
        noTransaction: 'You have no transactions yet',
        thankPurchase: 'Thanks for your purchase. Check your email for further instructions.',
        purchsInfo:
            'Subscribe for {{planMessages}} messages/{{planDays}} days. Free {{trialDays}}-day trial, then just {{planPrice}}/{{planDays}} days.',
        purchsInfoWithOffer:
            'Subscribe for {{planMessages}} messages/{{planDays}} days. Free {{trialDays}}-day trial, then just <s>{{basePrice}}</s> {{planPrice}}/{{planDays}} days.',
        subscribe: 'Subscribe for {{planMessages}} messages/{{planDays}} days.',
        pay: 'Pay {{number}}',
        somethingWentWrong: 'Something went wrong. Please try again.',
        paymentFormIncomplete: 'Please complete the card details before paying.',
        paymentMethodFailed: "We couldn't process that payment method. Please try again or use another.",
        cancelInfo: 'Subscription can be canceled at any time from customer profile',
        termsInfo: 'By paying, you agree to the',
        updated: 'Profile successfully updated',
        // HORO-10544: email/password users have no name on their account, so the
        // profile header would otherwise render an empty heading.
        addName: 'Add your name',
        namePlaceholder: 'Your name',
        emailLength: 'The email should have at most 50 characters',
        emailError: 'Email address must be a valid address',
        phone: 'Phone',
        optional: 'Optional',
        delSubscr: 'Subscription successfully deleted',
        confirmCancel: 'Confirm cancellation',
        nextPayment: 'The next payment will be charged on {{normalizedDateStr}}',
        // Cancelling stops the renewal but keeps access until the period ends.
        subscriptionEnds: 'Your subscription is cancelled and ends on {{normalizedDateStr}}. You keep full access until then.',
        oldLink: 'Old link no longer supported. Please update the page for new features. Apologies for any inconvenience.',
        sharedChatNote: 'This conversation was shared with you.',
        sharedChatStart: 'Start your own chat',
        sharedChatStartWith: 'Start your own chat with {{advisorName}}',
        paymentIssue: 'Payment issue.',
        paymentIssueNext: 'activation for continued access to x10 messages'
    },
    placeholders: {
        birthDate: 'Your birthplace',
        number: 'Please enter your phone number',
        numberShort: 'Enter phone number',
        birthTime: 'Your birthdate & birthtime',
        email: 'Please enter your email'
    },
    pages: {
        landing: {
            title: 'The World’s First AI Spiritual Guides'
        },
        home: {
            title: 'VEDA AI'
        },
        // HORO-10478 — subscription checkout page
        checkout: {
            title: 'Checkout',
            back: 'Go back',
            close: 'Close',
            payWith: 'Pay with',
            orPayByCard: 'Or pay by card',
            changePlan: 'Change plan',
            // HORO-10679: offered beside a one-off message pack, for the
            // customer who would rather not have the limit at all.
            goPremiumInstead: 'Go Premium instead',
            choosePlan: 'Choose your plan',
            perMonth: '/month',
            percentOff: '{{percent}}% off',
            pay: 'Pay {{price}}',
            terms: 'Terms',
            privacy: 'Privacy',
            processing: {
                subscription: 'Confirming your subscription',
                product: 'Confirming your purchase',
                wait: 'This takes a few seconds. Don’t close the window.'
            },
            alreadySubscribed: "You're already a subscriber, so there's nothing to pay for here.",
            viewSubscription: 'Manage my subscription',
            // Desktop only — the charge broken into line items, under the order
            // summary in the left column.
            breakdown: {
                period_one: '{{count}} month of premium',
                period_other: '{{count}} months of premium',
                discount: 'Launch discount ({{percent}}% off)',
                total: 'Total due today'
            },
            // Desktop only — sits under the order summary in the left column.
            desktopRenewal: {
                monthly: 'Renews {{date}} at {{price}}/month. Cancel anytime from your profile.',
                yearly: 'Renews {{date}} at {{price}}/year. Cancel anytime from your profile.',
                everyMonths: 'Renews {{date}} at {{price}} every {{months}} months. Cancel anytime from your profile.'
            },
            introPrice: {
                monthly: '{{price}} your first month',
                yearly: '{{price}} your first year',
                everyMonths: '{{price}} your first {{months}} months'
            },
            billedAt: {
                monthly: 'Billed monthly at {{price}}',
                yearly: 'Billed yearly at {{price}}',
                everyMonths: 'Billed every {{months}} months at {{price}}'
            },
            oneTimePurchase: 'One-time purchase of {{count}} messages',
            // The plan's own name says nothing about what it includes, and the
            // allowance is the thing being compared. Always from the plan, never
            // hardcoded: legacy Premium is capped at 200 while the plans on sale
            // are unlimited, so either half of this pair can be the right one.
            //
            // One pair for every surface that presents a plan — the checkout
            // cards and order summary, the switch tiles and the switch
            // confirmation — so the same claim cannot be worded two ways
            // depending on where a customer reads it (HORO-10682).
            entitlementUnlimited: 'Unlimited messages',
            entitlementCapped: '{{total}} messages a month',
            disclaimer: {
                // A message bundle is a one-off — nothing renews.
                product: "You'll be charged {{price}} today. One-time purchase, no subscription.",
                // `renewalPrice` is deliberately separate from `price`: with an
                // introductory offer the two differ, and one variable in both
                // positions stated that the intro price recurs forever.
                monthly:
                    "You'll be charged {{price}} today. Your plan renews {{renewalDate}} at {{renewalPrice}}, and every month after that, until you cancel.",
                yearly: "You'll be charged {{price}} today. Your plan renews {{renewalDate}} at {{renewalPrice}}, and every 12 months after that, until you cancel.",
                everyMonths:
                    "You'll be charged {{price}} today. Your plan renews {{renewalDate}} at {{renewalPrice}}, and every {{months}} months after that, until you cancel."
            }
        },
        // HORO-10703 — the /plans comparison page (Figma 7034:6 desktop,
        // 7034:262 mobile). Numbers are never written here: every count and
        // price is interpolated, from the tier catalog or the plan catalogue,
        // so the copy survives a limit or price change.
        plans: {
            title: 'Ask without limits',
            subtitle: 'Start free with Veda and Ophelia, or go Premium for unlimited conversations with every advisor.',
            compareTitle: 'Compare plans',
            currentPlan: 'Your plan',
            billingLabel: 'Billing period',
            savePercent: 'Save {{percent}}%',
            perMonth: '/month',
            comparisonCaption: 'Free vs Premium',
            comparisonFeature: 'What you get',
            pricingError: "We couldn't load pricing just now. Please refresh to try again.",
            // Shown only when the tier catalog is unreachable and the page fell
            // back to its built-in table — better to say so than to present
            // possibly-stale limits as current.
            indicativeTable: 'Plan limits shown are indicative. Your account page always shows what you currently have.',
            free: {
                name: 'Free',
                price: '$0',
                tagline: 'Get to know your advisors.',
                note: 'No card needed',
                cta: 'Start chatting',
                addOn: 'Need a few more? Add {{count}} messages to Free for {{price}}.',
                addOnCta: 'Add messages',
                notYourPlan: "You're on Premium — nothing here to switch to.",
                features: {
                    messages: '{{count}} messages a month',
                    tarot: '{{count}} tarot readings a month',
                    zara: 'A {{count}}-message trial with Zara',
                    birthChart: 'Your birth chart basics'
                }
            },
            premium: {
                name: 'Premium',
                tagline: 'Unlimited guidance, every advisor.',
                billedYearly: 'Billed yearly at {{price}}',
                cta: 'Get Premium',
                cancelAnytime: 'Cancel anytime from your profile',
                alreadyYours: 'This is your current plan.',
                features: {
                    messages: 'Unlimited messages and tarot readings',
                    advisors: 'Every advisor, including Zara',
                    birthChart: 'Your full birth chart and reports',
                    earlyAccess: 'First access to new advisors and features'
                }
            },
            groups: {
                conversations: 'Conversations',
                advisors: 'Advisors',
                chart: 'Your chart',
                extras: 'Extras'
            },
            rows: {
                messages: 'Messages',
                tarot: 'Tarot readings',
                loveTarot: 'Love tarot readings',
                zara: 'Zara, the love advisor',
                advisors: 'Premium advisors',
                birthChart: 'Birth chart',
                earlyAccess: 'New advisors and features'
            },
            values: {
                unlimited: 'Unlimited',
                perMonth: '{{count}} a month',
                zaraTrial: '{{count}}-message trial',
                allAdvisors: 'All advisors',
                notIncluded: 'Not included',
                fullReports: 'Full reports',
                limitedReports: 'Limited',
                firstAccess: 'First access'
            },
            faq: {
                title: 'Questions',
                billing: {
                    q: 'How does billing work?',
                    a: 'You pay for the whole period up front, monthly or yearly, and it renews on the same date until you cancel.'
                },
                cancellation: {
                    q: 'Can I cancel any time?',
                    a: 'Yes. Cancel from your account page and you keep Premium until the end of the period you have already paid for. Nothing is charged after that.'
                },
                unusedMessages: {
                    q: "What happens to messages I don't use?",
                    a: 'Free plan messages reset each month and do not roll over. Premium has no message limit, so there is nothing to carry.'
                },
                messagePacks: {
                    q: 'What if I run out on the Free plan?',
                    a: 'You can buy a message pack to keep the conversation going, or upgrade to Premium for unlimited messages.'
                }
            }
        },
        // Out-of-messages paywall (Figma 4167-16380).
        //
        // NOTE: this copy is from the design and promises "unlimited". The only
        // plan available today is 200 messages per 30 days, so the headline and
        // the first benefit overstate what is being sold. Product/Legal to
        // confirm before release — the unlimited plans arrive in HORO-10522.
        paywall: {
            wordmark: 'Veda.Astrology.com',
            title: 'Ask without limits',
            subtitle: 'A full year of clarity for less than one live session!',
            benefits: {
                messaging: 'Unlimited tarot readings & messaging',
                memory: 'Tracked predictions & personalized memory',
                birthChart: 'Generate your personal birth-chart',
                // The love advisor shipped as Zara (HORO-10521); this string
                // still said Zoe, her pre-launch name.
                zara: 'Message Zara, our premium love advisor',
                // HORO-10647: shown on every surface that renders this paywall.
                loveTarot: 'Love tarot readings, now live',
                reports: 'Monthly reports written just for you',
                earlyAccess: 'First access to new advisors and features'
            },
            frequency: {
                monthly: 'Monthly',
                yearly: 'Yearly',
                everyMonths: '{{months}} months'
            },
            billed: {
                monthly: 'Billed monthly',
                yearly: 'Billed yearly',
                everyMonths: 'Billed every {{months}} months'
            },
            billedYearlyAt: 'Billed yearly at {{price}}',
            continue: 'Subscribe',
            footnote: 'Subscription renews automatically unless cancelled at least 24 hours before the end of the current period.'
        },
        // HORO-10479 — post-purchase confirmation
        paymentSuccess: {
            subscription: {
                title: 'You’re in!',
                description: 'Unlimited readings, every advisor, and your birth chart whenever you want it.'
            },
            product: {
                title: 'You’re all set!',
                description: 'Your messages are ready — pick up right where you left off.'
            },
            plan: 'Plan',
            planValue: {
                monthly: '1 month (monthly)',
                yearly: '12 months (yearly)',
                everyMonths: '{{months}} months'
            },
            messages: 'Messages',
            messagesValue: '{{count}} messages',
            chargedToday: 'Charged today',
            renews: 'Renews',
            backToChat: 'Back to Chat',
            close: 'Close',
            receiptSentTo: 'Receipt sent to {{email}}'
        },
        payment: {
            title: 'Subscribe To Continue',
            titleOffer: "Unlock today's offer!",
            title1: 'Start Free {{trialDays}}-day Trial To Continue',
            title1Offer: 'Seems like you want to chat',
            title2: 'Are you sure you want to cancel?',
            title3: 'Payment Verification issue',
            title4: 'Subscription',
            title6: 'Unlock 10x more messages',
            offerTitle: 'Special offer',
            offerLabel: 'Unlock 10x more messages',
            offerLabelTrial: 'Start trial now to secure offer',
            label: 'Subscribe to enjoy 10x more messages',
            labelOffer: 'Subscription can be canceled at any time from customer profile',
            label1: 'Subscribe to enjoy 10x more messages',
            label1Offer: "We do too, so here's a special offer for you. First month for {{price}} after your FREE {{trialDays}}-day Trial.",
            label2: 'Whenever you need answers our guides are here.',
            label3: 'Retry subscription activation for continued access to x10 messages',
            price: '{{price}} per {{planDays}} days',
            priceOn: '{{price}} per {{planDays}} days billed on {{date}}',
            advice: 'Craving More Advice?',
            moreMessages: 'Unlock {{messagesCount}} messages for {{price}}',
            paymentProcess: 'Payment processing',
            paymentProcessDescription: 'Thanks for your purchase. Check your email for further instructions.',
            paymentNotWork: 'Oops. The payment didn’t work',
            paymentNotWorkError: 'Check your internet connection and try again.',
            phoneInfo: 'Add your phone number and get updates with your horoscope every day',
            confirmDelete: 'Are you sure you want to delete?',
            // HORO-10534: shown to subscribers before they confirm, because
            // deletion also cancels the subscription.
            //
            // This used to add "if you subscribed through the App Store or
            // Google Play, cancel it there as well", which was wrong on two
            // counts. Veda has no mobile app, so no account is billed by a
            // store — every subscription is provider `checkout`. And Apple Pay
            // and Google Pay are wallet methods *inside* that Checkout flow,
            // not store subscriptions, so a customer who paid by wallet was
            // being sent to look for a subscription in iOS Settings that was
            // never there. Cancelling here genuinely stops the billing: the
            // renewal cron only charges when it finds a non-deleted UserCard,
            // and cancellation soft-deletes the card.
            deleteCancelsSubscription: "This also cancels your Veda subscription — you won't be charged again.",
            messageMonth: 'Message per {{planDays}} days',
            msgAvailable: 'Messages available',
            getMore: 'Get {{messagesCount}} More Messages',
            until: 'Until:',
            active: 'active',
            inactive: 'inactive',
            planWithName: '{{planName}} subscription is',
            planWithoutName: 'Subscription is',
            bannerAlt: 'Banner avatars',
            expDate: 'Expired date',
            cardNumber: 'Card number'
        },
        chat: {
            privateLabel: 'Private chat',
            multiplyChat: '{{number}} members',
            wasRemoved: 'The chat was deleted',
            wasRemovedRequest: 'Please select the most relevant option for you',
            confirmDelete: 'Are you sure you want to delete the "{{-chatName}}"?',
            confirmDeleteText: 'Whenever you need answers our guides are here.',
            toMarketplace: 'Navigate on Marketplace',
            createChat: 'Create chat with {{alias}}'
        },
        userDeletionStatus: {
            requestNotFound: 'Request {{code}} was not found',
            requestStatus: 'Request {{code}} is {{status}}',
            emptyCodeError: 'Something went wrong - the code is empty',
            unknownError: 'Something went wrong while checking the request {{code}}. Please, try again later',
            updateStatus: 'Update status'
        },
        profile: {
            title: 'Profile',
            back: 'Go back',
            close: 'Close',
            logOut: 'Log Out',
            noBirthDate: 'Set birthdate for sign',
            // Fallback for a row with no prompt of its own — the email row,
            // which is display-only and has nothing to add.
            notSet: 'Not set',
            // Personal Information rows show their value, not their label, so an
            // empty one has to say which field it is. "Add …" matches the
            // legacy profile's prompt for a missing name.
            empty: {
                birthDate: 'Add birth date',
                birthTime: 'Add birth time for your Moon & Rising',
                birthPlace: 'Add birth place',
                phone: 'Add phone number',
                // HORO-10552: only Facebook signups that declined the email
                // permission ever see this — every other account has one.
                email: 'Add email',
                // The email/password signup creates accounts with no name, so
                // the identity card has nothing to show until they set one.
                name: 'Add your name'
            },
            planFree: 'Free Plan',
            planPremium: 'Premium Plan',
            sections: {
                personal: 'Personal Information',
                account: 'Account Management'
            },
            rows: {
                birthDate: 'Birth Date',
                birthTime: 'Birth Time',
                birthPlace: 'Birth Place',
                phone: 'Phone Number',
                email: 'Your Email',
                usage: 'Your Plan',
                plan: 'Your Plan',
                paymentMethod: 'Payment Method',
                paymentHistory: 'Payment History',
                deleteAccount: 'Delete Account'
            },
            edit: {
                birthDate: 'Edit Birth Date',
                birthTime: 'Edit Birth Time',
                birthPlace: 'Edit Birth Place',
                yourBirthDate: 'Your Birth Date',
                yourBirthTime: 'Your Birth Time',
                yourBirthPlace: 'Your Birth Place',
                update: 'Update',
                saving: 'Saving…',
                // HORO-10544's inline name edit, rehomed on the v2 identity
                // card. Deliberately under this namespace rather than reusing
                // the legacy page's `buttons.editName` / `labels.addName`, so
                // the two profiles' copy can diverge without one breaking the
                // other.
                editName: 'Edit your name',
                namePlaceholder: 'Your name',
                nameRequired: 'Please enter your name',
                // Not `errors.wrong`: this file still has two `errors:` blocks
                // on this branch, so the second shadows the first and every key
                // in it resolves to undefined. HORO-10544 merges them on
                // develop; until that lands, nothing here may depend on them.
                nameSaveFailed: "We couldn't save your name. Please try again.",
                // Phone number. Not in the profile v2 design — kept because the
                // legacy profile has the field and users have already filled it
                // in. The minimum interpolates as `min`, NOT `count`: `count`
                // is i18next's reserved pluralization key and would send it
                // looking for a `_other` variant of this string.
                phone: 'Edit Phone Number',
                yourPhone: 'Your Phone Number',
                optional: 'Optional',
                phoneTooShort: 'Enter at least {{min}} digits, or clear the field to remove it.',
                phoneSaveFailed: "We couldn't save your phone number. Please try again.",
                // HORO-10552. "Add", never "Edit": this screen is only reachable
                // while the account has no email, and it verifies the address by
                // code rather than saving it outright.
                email: 'Add Email',
                yourEmail: 'Your Email',
                emailPlaceholder: 'Enter email address',
                emailSendCode: 'Send verification code',
                emailSending: 'Sending…',
                emailCodeSent: 'Enter the 6-digit code we sent to {{email}}',
                emailVerify: 'Verify',
                emailVerifying: 'Verifying…',
                emailUseDifferent: 'Use a different email',
                emailInvalid: 'Enter a valid email address.',
                emailSendFailed: "We couldn't send a verification code. Please try again.",
                emailVerifyFailed: "That code didn't work. Please try again.",
                emailAlreadySet: "Your email address is already set and verified. It can't be changed here.",
                hour: 'Hour',
                minute: 'Minute',
                meridiem: 'AM or PM',
                // Birth date and time are one stored field, so there is no date
                // to attach a time to until a date exists.
                needBirthDateFirst: 'Set your birth date first, then choose a time.',
                // HORO-10581: an explicit answer, because noon used to mean
                // both "12 PM" and "unknown" and so could express neither.
                // HORO-10581: noon is the convention for an unknown birth time.
                // The hint exists so a seeker who DOES know theirs has a reason to
                // set it — the Ascendant is wrong ~91% of the time on a noon guess,
                // making it the highest-value correction they can make.
                timeDefaultHint:
                    "If you don't know your birth time, leave it at 12:00 PM — that's the standard default. " +
                    'Your Rising sign depends on the exact time, so add it here when you find it.',
                // The API returns 200 even when Google Places can't resolve the
                // place, so this covers "we said OK but nothing was saved".
                placeNotResolved: "We couldn't save that place. Try picking it from the list again."
            },
            toast: {
                birthDate: 'Birth date updated!',
                birthTime: 'Birth time updated!',
                birthPlace: 'Birth place updated!',
                name: 'Name updated!',
                phone: 'Phone number updated!',
                phoneCleared: 'Phone number removed.',
                email: 'Email added!'
            },
            // Your Account (HORO-10534). The design reads "messages left for
            // today" and "removes the daily limit", but the free tier is 20
            // messages per 30 days, so the daily framing would misdescribe the
            // product on the screen that asks the customer to pay for it.
            account: {
                onFreePlan: 'You are on free plan',
                freeMessages: '{{total}} free messages',
                // Shown instead once bundle messages are in play, when calling
                // the whole balance "free" would be untrue.
                messagesAvailable: '{{total}} messages available',
                messagesLeft: 'messages left this period',
                resetsOn: 'Resets on {{date}}',
                // The renewal cron refills the allowance shortly after the
                // period ends, so between the two the stored date is in the
                // past and printing it would read as a bug.
                resetsSoon: 'Resets soon',
                discount: '{{discount}}% off',
                // Two variants, picked from the plan's own entitlement. The
                // grandfathered $2.99 tier is capped at 200 messages and the new
                // Subscriber plans are genuinely unlimited (HORO-10504), so
                // "unlimited" cannot be hardcoded on a paywall.
                upsellTitleUnlimited: 'Unlock unlimited messages',
                upsellTitleCapped: 'Get {{total}} messages a month',
                upsellBodyUnlimited: 'Veda premium removes the monthly limit — from {{price}}/mo.',
                upsellBodyCapped: 'Veda premium raises your limit to {{total}} messages a month — from {{price}}/mo.',
                upsellCtaUnlimited: 'Unlock Unlimited Messages',
                upsellCtaCapped: 'Upgrade to Premium'
            },
            // Plan Management (HORO-10535). The entitlement line is chosen from
            // the plan's own limits rather than written: the grandfathered
            // $2.99 tier is capped at 200 messages while HORO-10504's newer
            // plans are uncapped, so neither word can be hardcoded.
            plan: {
                onPlan: 'You are on Veda {{name}}',
                unlimited: 'Unlimited plan',
                capped: '{{total}} messages a month',
                renews: 'Renews {{date}}',
                // Cancelling stops the renewal but keeps access to the end of
                // the period, so the same date means something different.
                ends: 'Ends {{date}}',
                // A renewal date that has already passed — the renewal is
                // overdue rather than upcoming.
                expired: 'Expired on {{date}}',
                perMonth: '/mo',
                // Spans the plan allowance and any message bundles bought on
                // top, which is why it is "available" rather than "left in your
                // plan".
                messagesAvailable: 'messages available',
                // HORO-10539: deferred plan switching.
                //
                // Two intros. The `legacy` pair is for a grandfathered $2.99
                // subscriber, whose plan is no longer in the catalogue and so
                // cannot be shown as a "Current" tile the way the design does —
                // their plan appears only in the card above. Leaving it cannot
                // be undone, which the design does not say and which is the
                // whole reason these strings exist.
                switchIntro: "You're on the {{name}} plan. Pick the plan you want to switch to.",
                // No price on the picker: a withdrawn plan is not in the
                // catalogue the client fetches, so the only trustworthy source
                // for what this customer pays is the server's preview — which
                // has not been called yet at this point. The confirm step, which
                // has it, states the figure.
                switchIntroLegacy: "You're on Veda premium, a plan that's no longer sold. Pick the plan you want to switch to.",
                switchWarningLegacy:
                    "Switching ends your current price for good. It's no longer sold, so you won't be able to get it back.",
                switchCta: 'Switch to {{name}}',
                switchCurrent: 'Current',
                confirmTitle: 'CONFIRM CHANGE',
                confirmBody: 'You keep your current benefits until {{date}} — the switch happens then, no refund now.',
                // "Once the switch takes effect", not "if you confirm": the
                // change is reversible until then, and saying otherwise would
                // be wrong in the customer's favour — which still generates
                // support contacts from people who cancelled and expected to
                // have lost the price.
                confirmWarningLegacy:
                    "Once the switch takes effect on {{date}}, your {{price}}/mo price ends permanently. It can't be restored, even if you cancel later.",
                confirmFrom: 'From',
                confirmTo: 'To',
                takesEffect: 'Switch takes effect',
                firstCharge: 'First charge',
                firstChargeValue: '{{price}} on {{date}}',
                chargedToday: 'Charged today',
                confirmCta: 'Confirm Change',
                confirmFootnote: 'Nothing changes until your current plan ends.',
                changedTitle: 'Plan changed',
                // Both prices, always. A switch is a price change first and a
                // plan change second, and naming only the new figure leaves the
                // customer to remember what they were paying.
                changedBody:
                    "Change scheduled. On {{date}} you'll move to {{name}}, and your price goes from {{fromPrice}}/mo to {{toPrice}}/mo.",
                changedKeepBenefits: 'You keep your current benefits until then.',
                // The only place the escape hatch is stated. Without it the
                // flow tells someone their price is ending while withholding
                // that it is still reversible.
                changedLegacyNote: 'Your {{price}}/mo price ends on {{date}}. Cancel this change before then if you want to keep it.',
                pendingNotice: "You're switching to {{name}} on {{date}} — {{fromPrice}}/mo becomes {{toPrice}}/mo.",
                pendingNoticeLegacy: 'Your current price ends then. Cancel this change before {{date}} if you want to keep it.',
                cancelPending: 'Cancel this change',
                switchError: "That change couldn't be made. Please try again.",
                switchErrorAlreadyOnPlan: "You're already on this plan.",
                switchErrorNoPlan: 'You need an active subscription to switch plans.',
                switchErrorStore: 'Your subscription is billed through the App Store or Google Play. Manage it there to change plans.'
            },
            // One-time message top-up, offered on both account screens. Count
            // and price interpolate from the product the segment is actually
            // sold — subscribers get the 200-message bundle, everyone else the
            // 20-message one — so neither figure is written here.
            bundle: {
                title: 'Need more messages?',
                body: 'Add {{total}} messages for {{price}}. A one-time top-up, not a subscription.',
                cta: 'Add {{total}} Messages'
            },
            // Payment Method (HORO-10538). View only — the design's "Update
            // Payment Method" link is a separate ticket and its copy is not
            // here.
            paymentMethod: {
                // Apple Pay and Google Pay are wallets used inside Checkout,
                // not App Store or Play Store subscriptions. Nothing on this
                // screen may suggest the customer manages billing anywhere but
                // here — we take the payment and we cancel it.
                instrument: {
                    apple_pay: 'Apple Pay',
                    google_pay: 'Google Pay'
                },
                cardNumber: '****{{last4}}',
                expires: 'Expires on {{month}}/{{year}}',
                // Figma writes "Connected to your walet"; the typo is not
                // reproduced.
                walletConnected: 'Connected to your wallet',
                subscription: 'Subscription',
                nextCharge: 'Next charge',
                loading: 'Loading…',
                error: "We couldn't load your payment method.",
                // A free user, and also a subscriber who has cancelled —
                // cancelling removes the stored card even though access runs to
                // the end of the paid period.
                none: 'No payment method on file.',
                footnote: 'Your card details are stored securely by our payment provider.'
            },
            // Placeholder body for detail views whose tickets haven't landed.
            comingSoon: "This screen isn't built yet.",
            // Shown in the desktop detail pane when no row is selected. Mobile
            // never sees it: there, the master IS the page until a row is tapped.
            emptyDetail: 'Select an item to view or edit it.'
        }
    },
    // HORO-10542: payment history rows. Shared by the standalone page and the
    // profile pane, so kept out of the `pages.profile` namespace.
    paymentHistory: {
        status: {
            completed: 'Completed',
            pending: 'Pending',
            failed: 'Failed'
        },
        // Derived from the billing period, not the plan's name — every plan we
        // sell is called "Premium", so the name would not say which one a row
        // is for.
        plan: {
            monthly: 'Monthly plan',
            yearly: 'Yearly plan',
            everyMonths: '{{months}}-month plan'
        },
        giftMessages: '{{total}} free messages',
        giftMessagesGeneric: 'Free messages',
        free: 'Free',
        // HORO-10538: the second half of the designed subtitle, "Yearly plan ·
        // Visa ****4242". A wallet row shows the wallet's name INSTEAD of a
        // scheme and last 4 — the stored digits belong to the device token
        // Checkout charges, not to the card in the customer's wallet app, so
        // they would be four digits the customer cannot find anywhere. Same
        // rule as the Payment Method screen, one screen away.
        method: {
            card: '{{scheme}} ****{{last4}}',
            // eslint-disable-next-line
            apple_pay: 'Apple Pay',
            // eslint-disable-next-line
            google_pay: 'Google Pay'
        }
    },
    // HORO-10541: the account-deletion flow.
    //
    // The copy states only what `deleteVedaUser` verifiably does: sign out,
    // soft-delete chats/messages/sessions, cancel the subscription, unsubscribe
    // from PostUp. The design's list also promised "your saved memories" and
    // "your profile and account details" — neither is touched by the deletion
    // routine, and nothing purges them later, so both were dropped rather than
    // shipped as a claim the customer consents on the strength of. The design's
    // "fully removed within 30 days / log back in to restore it" went for the
    // same reason: there is no purge job, and restoring only works on the OAuth
    // login path. See HORO-10518.
    deleteFlow: {
        confirmTitle: 'Delete your account?',
        confirmBody: "You'll be signed out and lose access to Veda. Here's what happens:",
        itemChats: 'Your chats and message history are deleted',
        itemSubscription: "Your subscription is cancelled — you won't be charged again",
        itemEmails: 'You stop receiving Veda emails',
        keep: 'Keep My Account',
        proceed: 'Continue to delete',
        confirmDeletion: 'Delete My Account',
        resultTitle: 'Account deleted',
        resultBody: "You've been signed out and your chats have been removed.",
        backToHome: 'Back to Veda',
        error: "We couldn't delete your account. Please try again.",
        reasons: {
            privacy_concerns: 'Privacy concerns',
            not_what_i_expected: 'Not what I expected',
            taking_a_break: 'Taking a break',
            something_else: 'Something else'
        }
    },
    // HORO-10545: the cancellation flow. Plan name interpolates the catalogue
    // plan's own name rather than the design's "Veda Plus", which the product
    // does not use anywhere — a rename in the DB then flows through with no
    // code change.
    cancelFlow: {
        planName: 'Veda {{name}}',
        planFallback: 'your subscription',
        confirmTitle: 'Cancel your subscription?',
        confirmBody: "You'll keep {{plan}} until {{date}}, then move to the free plan with limited messages.",
        confirmBodyNoDate: "You'll keep {{plan}} until the end of your billing period, then move to the free plan with limited messages.",
        keep: 'Keep Subscription',
        proceed: 'Cancel',
        confirmCancellation: 'Confirm Cancellation',
        resultTitle: 'Subscription cancelled',
        resultBody: "You'll keep {{plan}} until {{date}}, then move to free. If you change your mind, you can resubscribe anytime.",
        resultBodyNoDate:
            "You'll keep {{plan}} until the end of your billing period, then move to free. If you change your mind, you can resubscribe anytime.",
        backToChat: 'Back to Chat',
        error: "We couldn't cancel your subscription. Please try again.",
        reasons: {
            too_expensive: 'Too expensive',
            not_using_enough: 'Not using it enough',
            missing_features: 'Missing features I need',
            something_else: 'Something else'
        }
    },
    // HORO-10545: the shared "Before you go" survey, used by both the
    // cancellation and account-deletion flows. Only the reason labels differ
    // between them, and those are passed in by the caller.
    surveys: {
        title: 'Before you go',
        subtitle: 'Mind sharing why? It helps us improve. (Optional)',
        commentPlaceholder: 'Give us your thoughts!',
        // Skips the survey, not the action it belongs to.
        skip: 'Skip',
        submitting: 'Please wait…'
    },
    modal: {
        label2: 'Delete this chat? ',
        label3: 'You will not be able to restore it again',
        label4: 'To determine your zodiac sign (optional)',
        multiTitle: 'Share this chat to unlock group insights',
        multiSubtitle: 'Invite others to join the chat',
        authSecondTitle: 'Add birth details for more accurate readings and guidance',
        // HORO-10509: email/password signup + signin + password reset.
        orContinueWith: 'Or continue with',
        emailPlaceholder: 'Enter email address',
        alreadyHaveAccount: 'Already have an account?',
        signInLink: 'Sign in',
        noAccount: "Don't have an account?",
        signUpLink: 'Sign up',
        // Sign up (full-screen, Figma "Registration screen_general") —
        // replaces the old all-caps title1/label1 copy this component used
        // when it was still the modal's plain OAuth+email entry step.
        signUpTitle: "The conversation doesn't have to end here",
        signUpSubtitle: 'Create a free account for more predictions',
        signUpBenefit1: 'Tracked predictions & personalized memory',
        signUpBenefit2: 'Relaxed messaging limit',
        signUpBenefit3: '5 new specialized readers',
        // signUpBenefit4 ('Unlock tarot reading experience') removed —
        // tarot readings aren't part of this offering yet; see
        // BENEFIT_KEYS in EntryStep.js.
        // HORO-10495: tarot-limit entry-point variant (Figma "Registeration
        // screen_tarot", node 4510:25366) — shown instead of the generic
        // signUp* copy above when an anonymous user hits the tarot limit.
        // See REGISTER_UPSELL_VARIANT in const.js.
        tarotUpsellTitle: 'Clarity is one pull away',
        tarotUpsellSubtitle: 'Create a free account to pull your first spread',
        tarotUpsellBenefit1: 'Unlock tarot reading experience',
        tarotUpsellBenefit2: 'Increase messaging limit',
        tarotUpsellBenefit3: '5 new specialized readers',
        tarotUpsellBenefit4: 'Tracked predictions & personalized memory',
        // HORO-10502: memory-restriction entry-point variant (Figma
        // "Registeration screen_memory", node 4510:25367) — shown when an
        // anonymous user taps "Memory" in the nav.
        memoryUpsellTitle: 'Every reading sharpens the next one',
        memoryUpsellSubtitle: 'Create a free account to access memory',
        memoryUpsellBenefit1: 'Tracked predictions & personalized memory',
        memoryUpsellBenefit2: 'Increase messaging limit',
        memoryUpsellBenefit3: 'Unlock tarot reading experience',
        memoryUpsellBenefit4: '5 new specialized readers',
        // HORO-10499: chat-history-restriction entry-point variant (Figma
        // "Registeration screen_chat history", node 4510:25368) — shown when
        // an anonymous user taps "Chat History" in the nav.
        chatHistoryUpsellTitle: 'Some conversations are worth a second look',
        chatHistoryUpsellSubtitle: 'Create a free account for your full chat history',
        chatHistoryUpsellBenefit1: 'Tracked predictions & personalized memory',
        chatHistoryUpsellBenefit2: 'Increase messaging limit',
        chatHistoryUpsellBenefit3: 'Unlock tarot reading experience',
        chatHistoryUpsellBenefit4: '5 new specialized readers',
        // HORO-10504: locked-advisor entry-point variant — shown when an
        // anonymous user taps a catalog advisor outside the anonymous-tier
        // allowlist. Reuses signUpBenefit1-3 (see VARIANT_COPY in
        // EntryStep.js), just its own title/subtitle.
        advisorLockedUpsellTitle: "You're one step from your reading",
        advisorLockedUpsellSubtitle: 'Create a free account to unlock this advisor',
        setPasswordTitle: 'Enter password',
        // Desktop-only — confirmed via Figma inspector on "Registeration_
        // general": the desktop Set password card uses different title/
        // subtitle copy than mobile's Enter Password screen.
        setPasswordTitleDesktop: 'Set password',
        setPasswordSubtitleDesktop: "Enter something that you won't forget",
        // Unused since the live PasswordRequirementsChecklist replaced this —
        // kept in case a future entry-point variant wants a subtitle here.
        setPasswordLabel: 'Choose a password to protect your account',
        passwordPlaceholder: 'Password',
        passwordRule: {
            atLeast8Chars: 'Passwords must be at least 8 characters long',
            atLeastOneNumber: 'Passwords must be at least 1 number (0-9)',
            atLeastOneUppercase: 'Passwords must have at least 1 uppercase letter (A-Z)',
            atLeastOneUniqueChar: 'Passwords must have at least 1 unique character'
        },
        passwordFieldLabelConfirm: 'Confirm password',
        confirmPasswordPlaceholder: 'Confirm password',
        // Was all-caps — every title on the new email/password screens
        // (confirmed via Figma inspector: Welcome back, Enter password,
        // Verify your email) is actually mixed-case Instrument Serif, not
        // the legacy modal's uppercase Khand convention.
        verifyEmailTitle: 'Verify your email',
        verifyEmailLabel: 'Enter the 6-digit code we sent to {{email}}',
        editEmail: 'Edit',
        codePlaceholder: 'Enter code',
        resendCode: "Didn't get it?",
        resendCodeAction: 'Resend',
        resendCodeThrottled: 'Resend available in {{seconds}}s',
        // ResetPasswordStep's countdown — `{{time}}` is already mm:ss
        // formatted (see formatCountdown there), matches EMAIL_CODE_TTL_SEC
        // on the backend (media-ai-veda-backend src/utils/consts.ts).
        codeExpiresIn: 'Code expires in {{time}}',
        codeExpired: 'Code expired — request a new one',
        signInTitle: 'Welcome back',
        // Unused — Figma's mobile "Welcome back" screen has no subtitle.
        // Kept in case a future variant wants one.
        signInLabel: 'Sign in to continue',
        // Desktop-only — confirmed via Figma inspector: the desktop card
        // has a subtitle mobile doesn't.
        signInSubtitleDesktop: 'Enter your details to sign back in.',
        emailFieldLabel: 'Email address',
        passwordFieldLabel: 'Password',
        enterPasswordPlaceholder: 'Enter password',
        // Mixed case per the same confirmed convention as the other new
        // titles. Confirmed via Figma (4542:50168 desktop / 4517:30849
        // mobile, "Reset your password") — both breakpoints share this
        // exact title/subtitle/helper copy.
        forgotPasswordTitle: 'Reset your password',
        // HORO-10509: deliberately hedged ("if an account exists") rather
        // than "we sent a code to {{email}}" — this is the copy shown on
        // the request screen always, whether or not the email actually
        // has an account, matching the backend's own enumeration-safe
        // behavior (emailForgotPassword's response is identical either
        // way — see authSlice's comment on that thunk). Never swap this
        // for account-existence-specific copy.
        forgotPasswordLabel: 'If an account exists for this email, we sent a code.',
        forgotPasswordHelperText: 'The address you signed up with.',
        // HORO-10509: title for ResetPasswordCodeStep, the code-entry half
        // of the reset-password flow (split from the password half below
        // — see ResetPasswordStep's comment). No Figma frame of its own;
        // the original combined screen's frames never showed a code field
        // at all (see resetPasswordTitle's comment).
        resetPasswordCodeTitle: 'Enter your code',
        // HORO-10509 (Figma 4542:52114 / 4690:8442 desktop, 4517:31391
        // mobile, "Set a new password"): single new-password field, no
        // confirm-password field — this screen now adds one anyway (see
        // ResetPasswordNewPasswordStep's comment), so it no longer
        // matches those frames exactly.
        resetPasswordTitle: 'Set a new password',
        // Unused — ResetPasswordCodeStep shows `verifyEmailLabel` instead
        // (the code-entry instruction), since this screen turned out to
        // need an OTP box those Figma frames didn't show — see the
        // component's own comment. Kept in case a future link-based reset
        // flow (no code box) revives this literal copy.
        resetPasswordSubtitle: "You'll use this next time you sign in.",
        resetPasswordSubtitleDesktop: "You're signed in once you save it.",
        newPasswordFieldLabel: 'New password',
        // ResetPasswordNewPasswordStep's second field — SetPasswordStep's
        // signup screen uses the plain `passwordFieldLabelConfirm` for
        // its own confirm field; this one calls out "new" explicitly
        // since "Confirm password" alone reads ambiguously right next to
        // a screen titled "Set a new password".
        confirmNewPasswordFieldLabel: 'Confirm new password',
        confirmNewPasswordPlaceholder: 'Confirm new password',
        emailAlreadyExists: 'An account with this email already exists.',
        // Figma "New password confirmation" shows this on the chat page
        // post-auto-login — the actual endpoint returns no tokens/user
        // (confirmed against the backend), so this now shows on the Sign
        // in screen instead. Still accurate copy either way (the password
        // really was updated), just a different screen than Figma depicts.
        passwordResetSuccessToast: 'New password updated!',
        signInSuccessToast: 'Welcome back!',
        accountCreatedToast: 'Account created successfully',
        addEmailTitle: 'Add your email',
        addEmailLabel: 'We need an email address on file to keep your account secure and let you know about changes.',
        vedaTitle: 'Veda AI Astrologers',
        vedaSubtitle:
            "You are interacting with an AI system, not a human. Outputs are provided for entertainment purposes only and should not be used for financial, medical, legal, or safety decisions. If you are in crisis, contact emergency services. For adults 18+ only. By continuing, I agree to Astrology.com's Terms of Service."
    },
    toastMessages: {
        noSupportLink: 'Old link no longer supported. Please update the page for new features. Apologies for any inconvenience.'
    },
    memory: {
        title: 'MEMORY',
        enabled: 'Memory enabled',
        disabled: 'Memory disabled',
        yourWorld: 'Your World',
        yourLens: 'Your lens',
        yourGoals: 'Your goals',
        overview: 'Overview',
        keyIndividuals: 'Key individuals',
        currentTopics: 'Current topics',
        keyMilestones: 'Key milestones',
        beliefs: 'Beliefs',
        ambitions: 'Ambitions',
        edit: 'Edit',
        save: 'Save',
        cancel: 'Cancel',
        editInstruction: "Correct anything that's no longer true - Veda will adjust it",
        updated: 'Memory is updated!',
        regionUnavailable: 'Memory is not available in your region',
        deleteAll: 'Delete all memory',
        deleteAllTitle: 'Delete all memory?',
        deleteAllDescription: "Once deleted, your memories can't be recovered. Veda will no longer know who you are.",
        deleteConfirm: 'Yes, delete memory',
        deleteCancel: 'Not yet',
        unsavedTitle: 'You have unsaved changes!',
        unsavedDescription: 'If you leave now, your edits will be lost.',
        unsavedConfirm: 'Leave',
        unsavedCancel: 'Stay',
        disabledDescWorld: 'Your relationships, milestones, and life context - all in one place. Veda builds this as you talk.',
        disabledDescLens: 'Your beliefs, patterns, and how you see the world. Veda learns to read between the lines.',
        disabledDescGoals: "What you're working toward. Veda keeps this in mind so every reading stays relevant.",
        returningModal: {
            title: 'NEW: VEDA MEMORY',
            subtitleMobile: 'Guidance that gets sharper over time.',
            subtitleDesktop:
                'Guidance that gets sharper over time. Veda remembers your story, so every reading builds on the last instead of starting over.',
            bullet1Desktop: 'Readings tuned to you',
            bullet1Desc: 'that reflect your real circumstances, not generic horoscopes.',
            bullet2Desktop: 'No more starting over',
            bullet2Desc: 'since Veda remembers your situation, your people, and your patterns.',
            bullet3Desktop: 'Your story, your control',
            bullet3Desc: 'to turn memory on or off anytime. Veda remembers only what you want.',
            cta: 'Turn On Memory'
        },
        anonymousModal: {
            title: 'Unlock Personalized Guidance',
            subtitleMobile: 'Sign up to supercharge your Veda experience',
            subtitleDesktop: 'Sign up to supercharge your Veda experience',
            bullet1Bold: 'Higher daily message limits',
            bullet1Desc: 'for deeper conversations.',
            bullet2Bold: 'Unlimited Tarot readings',
            bullet2Desc: 'completely on-demand.',
            bullet3Bold: 'Persistent memory',
            bullet3Desc: 'so Veda knows your story and saves readings for increasingly accurate predictions.',
            footer: 'Already have an account?',
            footerLink: 'Sign in'
        }
    },
    // HORO-10471: Live Readings waitlist — fake-door demand test. Copy is
    // verbatim from Figma 4389:27705 / 4480:13663 / 4440:28227 / 4440:28056.
    // The headline is split so "Veda" can carry the Instrument Serif italic
    // treatment (same as the AnonHomePage hero).
    liveReadings: {
        navLabel: 'Live Readings',
        soonBadge: 'Soon',
        eyebrow: 'Join waitlist for first access',
        headline: 'Real astrologers are coming to',
        headlineBrand: 'Veda',
        body: 'Veda and her characters are AI. For the moments that call for a human, we’re bringing in real astrologers for deeper, one-on-one guidance.',
        valueProps: {
            liveTitle: 'Live sessions',
            liveDesc: 'Sit with a real astrologer, one-on-one.',
            videoTitle: 'Video readings',
            videoDesc: 'Personalized readings recorded for you by astrology creators.'
        },
        emailPlaceholder: 'Enter email',
        emailInvalid: 'Please enter a valid email address',
        joinCta: 'Join waitlist',
        // Explicit decline in the promo modal (Figma 4481:20887 / 4481:14168).
        notInterested: 'Not Interested',
        joinError: 'Something went wrong. Please try again.',
        finePrint1: 'Not live yet. You’ll be the first to be notified.',
        finePrint2: 'Sessions will be paid',
        finePrint3: 'No spam. Just live readers, coming later this year',
        joinedTitle: 'You’re on the waitlist!',
        joinedSubtitle: 'Thanks for signing up. We’ll notify you when your access is unlocked.',
        toastJoined: 'You have joined the waitlist!',
        toastDismiss: 'Dismiss'
    },
    // HORO-10639: Keen human-psychic upsell, shown to anonymous users only.
    // `adLabel` is a disclosure, not decoration — the chat card is paid
    // placement inside a conversation, so it has to say so.
    // HORO-10679: the in-chat top-up offered after a free-plan customer closes
    // the out-of-messages paywall. Count and price interpolate from the product
    // the segment is actually sold, same as the account-screen bundle card, so
    // neither figure is written here.
    messagePackOffer: {
        lead: "That's your {{total}} free messages. There's more here worth talking through.",
        cta: 'Keep Going · {{price}}',
        terms: '{{total}} more messages, paid once. Nothing renews.',
        purchased: '{{total}} messages added'
    },
    keenUpsell: {
        adLabel: 'Advertisement',
        // One offer, two framings — the variant is picked per visitor and
        // reported to GA4 as `copy_variant` (see keenCopyVariant).
        chat: {
            subtitle: 'Your first 3 minutes for free · Chat or call',
            dismiss: 'Close advertisement',
            variants: {
                live_reading: {
                    title: 'Want a live reading with a Keen advisor?',
                    cta: 'Find an advisor'
                },
                human_take: {
                    title: 'Want a human take on this?',
                    cta: 'Visit Keen'
                }
            }
        },
        catalog: {
            eyebrow: 'WANT A HUMAN READ?',
            headline: 'Talk one-on-one with a real psychic, live.',
            cta: 'Browse real psychics'
        }
    },
    // HORO-10504/10599: Zara premium-advisor upsell modal, shown from her
    // locked catalog card — now two variants of the same hero shell
    // (ZaraModalShell), chosen by viewer state (see ZaraUpsellModal):
    //   - register (anon): eyebrow/titleLead/titleAccent below, "Send 3
    //     messages for free" under a "Register to Chat" CTA.
    //   - subscribe (registered, trial exhausted): premiumEyebrow/
    //     continueTitle repurpose the same hero, subscribeCta persists.
    // `titleLead`/`titleAccent` are split so only "yet." gets the italic
    // serif accent treatment (see ZaraUpsellModal styles).
    zaraUpsell: {
        eyebrow: 'NEW ADVISOR ON VEDA!',
        titleLead: 'Meet Zara! The most precise love advisor ',
        titleAccent: 'yet.',
        registerSubtext: 'Send 3 messages for free',
        registerCta: 'Register to Chat',
        premiumEyebrow: 'PREMIUM ADVISOR ON VEDA!',
        continueTitle: "There's more to say about your love life.",
        valueProp1Title: 'Grounded in real astrological practice',
        valueProp1Desc: 'Real charts, planet transits and based on current sky.',
        valueProp2Title: 'Exact answers about your love life',
        valueProp2Desc: "What's coming, when, and why.",
        valueProp3Title: 'Premium love tarot',
        valueProp3Desc: 'The one worth subscribing for a sharper reading.',
        subscribeCta: 'Subscribe to Chat',
        backToChat: 'Back to Chat'
    },
    // HORO-10504: one-time "first time in Zara" welcome screen for a premium
    // subscriber's first visit to her chat (Figma nodes 431-3281 mobile /
    // 561-1714 desktop) — reuses zaraUpsell's eyebrow/title above (same hero
    // section, per design). Each chip is sent verbatim as the first message
    // in a brand-new chat with Zara. Desktop's frame has a 4th chip ("Just
    // read my chart") the mobile frame is missing — treated as a mobile
    // frame oversight and shipped on both breakpoints.
    zaraWelcome: {
        chip1: 'When will love finally arrive?',
        chip2: 'Where is this relationship going?',
        chip3: 'Should I hold on or let go?',
        chip4: 'Just read my chart'
    },
    // HORO-10360: Birth Chart flow. `view`, `flow` and `card` live next to their
    // components; the surrounding entry points are here.
    birthChart: {
        pill: 'Birth Chart',
        menu: 'Birth Chart',
        profile: {
            row: 'Birth Chart',
            waiting: 'Your birth chart is waiting',
            noChart: 'Add your birth details to see your birth chart.',
            start: 'Build my chart'
        },
        view: birthChartViewCopy,
        flow: birthChartFlowCopy,
        card: birthChartCardCopy
    }
};
